import { Breakpoints, styled } from "@vw-marketing/us-components";

export const StyledReviewsDisclaimer = styled.div`
display: flex;
flex-direction: column;
row-gap: 15px;

.disclaimer-text {
    color: #6A767D;
}

.no-reviews-text {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 44px;
    @media (min-width: ${Breakpoints.b960}px) {
        padding-top: 80px;
        padding-bottom: 90px;
    }
}
`